import { LinearProgress as LinearProgressMui } from "@mui/material";

const LinearProgress = ({
  className,
  classes,
  color,
  value,
  valueBuffer,
  variant,
  sx,
  style,
}) => {
  return (
    <LinearProgressMui
      className={className}
      classes={classes}
      color={color}
      value={value}
      valueBuffer={valueBuffer}
      variant={variant}
      sx={sx}
      style={style}
    />
  );
};

export default LinearProgress;
